// This is generated.  Alter it in blockGroups/dataViews/types/FixedText.js
/* eslint-disable no-unused-vars */
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode) {
    // a paragraph of text does not contribute to any data formats
    return [{}, {}];
  },
};
moduleRegistration.registerHNodeType('dataViews', 'FixedText', module.exports);
